import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { UserService } from '../../../service/user.abstract.service';
import { Subject, Observable, combineLatest, of, ReplaySubject } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UserRequest } from '../../../user.model';
import { map, takeUntil } from 'rxjs/operators';
import { Organisation } from '../../../../global/global.model';
import { Map, TileLayer, Marker, LatLng, LatLngBounds } from 'leaflet';
import { TranslateService } from '@ngx-translate/core';
import { ModalImageComponent } from '../../../../global/components/common/modal-image/modal-image.component';
import { organisationSelector } from 'src/app/global/store/global.selectors';
import { Store } from '@ngrx/store';
import { State } from 'src/app/store';
import { MAP_TILE_ATTRIBUTION, MAP_TILE_URL } from 'src/app/global/consts/map-tiles.const';

@Component({
    selector: 'app-user-request-detail',
    templateUrl: './user-request-detail.component.html',
    styleUrls: ['./user-request-detail.component.scss'],
})
export class UserRequestDetailComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();
    request: UserRequest;

    loading = false;

    map: Map;
    tileLayer: TileLayer;
    marker: Marker;

    displayedColumns = ['isPublic', 'requestNum', 'userName', 'category', 'updated_at', 'status'];

    constructor(
        private translateService: TranslateService,
        private userService: UserService,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<UserRequestDetailComponent>,
        private store: Store<State>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    ngOnInit() {
        this.loading = true;
        combineLatest([this.userService.getRequestDetail(this.data.id), this.store.select(organisationSelector)])
            .pipe(
                takeUntil(this.destroy$),
                map(([req, org]) => {
                    this.request = req;
                    this.createMap(req, org);
                    this.loading = false;
                }),
            )
            .subscribe();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    createMap(req: UserRequest, org: Organisation) {
        if (!req?.address?.latitude || !req?.address?.longitude) {
            return;
        }
        this.map = new Map('requests-map', {
            zoomControl: true,
            preferCanvas: true,
            center: new LatLng(req.address.latitude, req.address.longitude),
            zoom: 15,
            minZoom: 13,
            maxBounds: new LatLngBounds([
                [org.bounds.southWest.lat, org.bounds.southWest.lon],
                [org.bounds.northEast.lat, org.bounds.northEast.lon],
            ]),
        });
        this.tileLayer = new TileLayer(MAP_TILE_URL, { attribution: MAP_TILE_ATTRIBUTION });
        this.tileLayer.addTo(this.map);
        this.marker = new Marker(new LatLng(req.address.latitude, req.address.longitude));
        this.marker.addTo(this.map);
    }

    closeDialog() {
        this.dialogRef.close();
    }

    dateToString(str: string) {
        const date = new Date(str);
        return new Intl.DateTimeFormat(`${this.translateService.currentLang}-CA`).format(date);
    }

    viewImage(img: string) {
        this.dialog.open(ModalImageComponent, {
            maxWidth: '100vw',
            maxHeight: '100vh',
            data: { src: img },
            panelClass: 'image-dialog',
        });
    }
}
